module.exports = __webpack_public_path__ + "files/2c5d7d0c216065add212fe3c041b36e4.png";